export default {"src":"/_next/static/media/RY.d565a358.svg","height":18,"width":18};